import React, {useState, useRef, useEffect} from 'react';
import styles from './styles';
import {IconTextButton} from '@xpertdox_js/xdcomponents';
import {btn_c_lightGreen} from '@xpertdox_js/xdstyle';
import FormInstance from './FormInstance';

const IncrementForm = props => {
  const {formSchema} = props;
  const formRef = useRef(null);
  const {forms, setForms} = props;

  // complie forms
  const compileForms = () => {
    let fromProps = {};
    props.values.forEach(val => {
      let formStore = [];
      Object.keys(formSchema).forEach(property =>  {
        let formattedVal = {};
        const schemaSettings = formSchema[property]
        if (!schemaSettings) throw new Error('Schema not set for property: ' + property); // flag dev that schema is not set for this property
        // ---- SCHEMA OPTIONS/SETUP
        formattedVal.id = property; // set form input id from form schema
        formattedVal.type = schemaSettings.type;
        formattedVal.value = val[property];
        formattedVal.notRequired = !schemaSettings.required;
        formattedVal.options = schemaSettings.options;
        formattedVal.labelStyles = schemaSettings.labelStyles;
        formattedVal.label = schemaSettings.label;
        formStore.push({...formattedVal})
      })
      fromProps[Math.random().toString(36).substring(7)] = formStore;
    });
    setForms(fromProps)
    formRef.current = fromProps;
  }

  // compile forms based on props
  useEffect(() => {
    if (formRef.current === null) compileForms(); // initial
  }, [props.values])

  const removeForm = id => {
    let update = {...forms};
    delete update[id];
    setForms(update);
    formRef.current = update;
  }

  const addForm = () => {
    let formStore = [];
    if(props.addToggle && !props.toggle) props.addToggle()
    Object.keys(formSchema).forEach(property =>  {
      let formattedVal = {};
      const schemaSettings = formSchema[property]
      if (!schemaSettings) throw new Error('Schema not set for property: ' + property); // flag dev that schema is not set for this property
      // ---- SCHEMA OPTIONS/SETUP
      formattedVal.id = property; // set form input id from form schema
      formattedVal.type = schemaSettings.type;
      formattedVal.notRequired = !schemaSettings.required;
      formattedVal.value = undefined;
      formattedVal.options = schemaSettings.options;
      formattedVal.labelStyles = schemaSettings.labelStyles;
      formattedVal.label = schemaSettings.label;
      formStore.push({...formattedVal})
    })
    setForms({
      ...forms,
      [Math.random().toString(36).substring(7)]: formStore
    })
  }

  const formValues = Object.values(forms);
  const formKeys = Object.keys(forms);


  return(
    <div style={styles.container}>
      {formValues && formValues.map((formSettings, i) =>
        <FormInstance
          key={formKeys[i]}
          formSettings={formSettings}
          removeForm={() => removeForm(formKeys[i])}
          formId={formKeys[i]}
          setStateCallback={(val) => props.setForms({
            ...props.forms,
            [formKeys[i]]: props.forms[formKeys[i]].map(field => ({...field, value: val[field.id]})),
          })}
        />)
      }
      <IconTextButton
        icon='plus'
        text='Add New'
        onClick={addForm}
        preBuiltStyles={btn_c_lightGreen}
      />
    </div>
  );
}

export default IncrementForm;
